import React, { useMemo } from 'react';
import { DragObjectWithType, useDrag } from 'react-dnd';

import { useWindowSize } from 'react-use';

export interface BoxDndDragItem extends DragObjectWithType {
  type: 'box';
  bottom: number;
  right: number;
}

export interface BoxDndProps extends React.HTMLAttributes<HTMLDivElement> {
  item: BoxDndDragItem;
  hideSourceOnDrag?: boolean;
}

const BoxDnd: React.FC<BoxDndProps> = ({ item, hideSourceOnDrag, ...rest }) => {
  const [{ isDragging }, drag] = useDrag({
    item,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const { width, height } = useWindowSize();

  const style = useMemo<React.HTMLAttributes<HTMLDivElement>['style']>(() => {
    // TODO calculate chilren size and make header boundary configurable
    const maxWidth = width - 56;
    const maxHeight = height - (56 + 60);
    const right = item.right > maxWidth ? maxWidth : item.right;
    const bottom = item.bottom > maxHeight ? maxHeight : item.bottom;
    return { position: 'absolute', bottom, right };
  }, [item, width, height]);

  if (isDragging && hideSourceOnDrag) {
    return <div ref={drag} />;
  }
  return <div ref={drag} style={style} {...rest} />;
};

export default BoxDnd;
